/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { accountDataOrganizationSchema } from "../accountDataOrganizationSchema.ts";
import { errorResponseSchema } from "../errorResponseSchema.ts";
import { z } from "zod";

export const getOrganizationByIdPathParamsSchema = z.object({
      "id": z.string().describe("ID unique de l'organisation à récupérer.")
      })

export const getOrganizationByIdHeaderParamsSchema = z.object({
      "X-Client-Id": z.string().describe("ID du client/application pour lequel récupérer les informations utilisateur.")
      })

/**
 * @description Organisation trouvée avec succès.
 */
export const getOrganizationById200Schema = z.lazy(() => accountDataOrganizationSchema)

/**
 * @description Réponse d\'erreur standard
 */
export const getOrganizationById500Schema = z.lazy(() => errorResponseSchema).describe("Réponse d'erreur avec message et code de statut")

export const getOrganizationByIdQueryResponseSchema = z.lazy(() => getOrganizationById200Schema)